/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StoreManagementCreateSaleResponse } from './StoreManagementCreateSaleResponse';

export type StoreManagementCreateSaleResponseApiRespoonse = {
    data?: StoreManagementCreateSaleResponse;
    status?: StoreManagementCreateSaleResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace StoreManagementCreateSaleResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

